import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';

import { TIME_CONSTANTS } from '../../../constants/times';

const PureLayoutPopup = dynamic(() => import('./PureLayoutPopup'), {
  ssr: false,
});

const LayoutPopup = ({ data }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const lastShownDate = localStorage.getItem('layout_popup_last_shown');
    const today = new Date().toDateString();

    if (lastShownDate !== today) {
      // Show popup and update localStorage after 30 seconds
      const timer = setTimeout(() => {
        setShow(true);
        localStorage.setItem('layout_popup_last_shown', today);
      }, TIME_CONSTANTS.COMMON_AD_BANNER_DELAY);

      return () => clearTimeout(timer);
    }
  }, []);

  if (!show) {
    return null;
  }

  return <PureLayoutPopup data={data} show={show} setShow={setShow} />;
};
export default LayoutPopup;
